import { history as historyRouter } from 'instantsearch.js/es/lib/routers'
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings'

import { IndexUiState, UiState } from 'instantsearch.js/es/types/ui-state'

/**
 * Two searches on one page share an index name, so they would otherwise read and write
 * the same URL params. A stateKey scopes each one to its own key; it defaults to the
 * index name, which is what a single search on a page already used.
 */
export function getSearchRouting(indexName: string, stateKey?: string) {
  const scope = stateKey || indexName
  const stateMapping = singleIndex(indexName)

  return {
    router: historyRouter({ cleanUrlOnDispose: false }),
    stateMapping: {
      $$type: 'ais.scopedIndex',
      stateToRoute: (uiState: UiState) => ({ [scope]: stateMapping.stateToRoute(uiState) }),
      routeToState: (routeState: Record<string, IndexUiState> = {}) => stateMapping
        .routeToState(routeState[scope] ?? {}),
    },
  }
}
